import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as UserService from 'services/iam/user';

export const useUserService = () => {
  const { id: user_id, token } = useSelector((store) => store.user_data);

  const acceptInvitation = async (options = {}) => {
    const { error, payload } = await UserService.acceptInvitation({
      ...options,
      token
    });
    if (error) {
      toast.error('Unable to accept invitation at this time.');
      return null;
    }

    return payload;
  };

  const fetchOrganizations = async (options = {}, show_inactive = false) => {
    const { error, payload } = !show_inactive
      ? await UserService.readActiveOrganizations(user_id, {
          ...options,
          token
        })
      : await UserService.readOrganizations(user_id, {
          ...options,
          token
        });
    if (error) {
      return { organizations: [], size: 0 };
    }

    const {
      data: organizations,
      meta: { size }
    } = payload;
    return { organizations, size };
  };

  const fetchUserData = async (options = {}) => {
    const { payload } = await UserService.readById(user_id, { ...options, token });
    return { user: payload };
  };

  const updatePassword = async (id, options = {}) => {
    const { payload } = await UserService.updatePassword(id, {
      ...options,
      token
    });
    return payload;
  };

  const updateUserData = async (id, options = {}) => {
    const { error, payload } = await UserService.updateById(id, {
      ...options,
      token
    });
    if (error) {
      toast.error(error);
    }

    return payload;
  };

  return { acceptInvitation, fetchOrganizations, fetchUserData, updatePassword, updateUserData };
};
